import { useEffect, useRef } from 'react';
import { useForm } from 'react-final-form';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import { deliveryStepAnalytics as analytics } from '../../analytics';

type TFields = 'deliveryAddress';

export const FormSpyLocal = () => {
    // Сохраняем предыдущее активное поле
    const prevActiveField = useRef<TFields | undefined>(undefined);
    const state = useForm().getState();

    const { active, errors, touched, values } = state;

    useEffect(() => {
        const activeField = active as TFields | undefined;
        // Проверка на blur: если нет активного поля, и у нас есть прошлое активное поле,
        // значит мы только что из него вышли
        if (!activeField && prevActiveField.current) {
            const isTouched = touched?.[prevActiveField.current];
            const isError = errors[prevActiveField.current];
            const hasValue = values[prevActiveField.current];
            const hasAnalytics = analytics.formFields[prevActiveField.current];

            if (hasAnalytics && isTouched && isError) {
                sendEvent(analytics.formFields[prevActiveField.current].incorrect);
            }
            if (hasAnalytics && isTouched && hasValue && !isError) {
                sendEvent(analytics.formFields[prevActiveField.current].correct);
            }

            // Проверка на focus: есть активное поле, и оно отличается от прошлого
        } else if (
            activeField &&
            activeField !== prevActiveField.current &&
            analytics.formFields[activeField]
        ) {
            sendEvent(analytics.formFields?.[activeField].focus);
        }
        prevActiveField.current = active as TFields;
    }, [active, errors, touched, values]);

    return null;
};
